import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';
import PedidosNavbar from './pedidos/PedidosNavbar'

const RootStyle = styled('div')(({ theme }) => ({
	height: '100%',
	padding: '80px 0px 50px 0px'
}));

export default function AvaliacaoLayout() {
	return <>
		<PedidosNavbar menu={false} title='Avaliação' />
		<RootStyle>
			<Grid container justifyContent='center' sx={{ height: '100%' }} >
				<Grid item xs={12} md={4} sx={{ height: '100%' }}>
					<Container sx={{ height: '100%' }}>
						<Outlet />
					</Container>
				</Grid>
			</Grid>
		</RootStyle>
	</>
}
